// extracted by mini-css-extract-plugin
export default {"inputMargin":"OTPInput_inputMargin__BhR1j","inputColor":"OTPInput_inputColor__zOjUF"};